import { FACTIONS } from "@/data";
import { selectActiveForce, useForceStore } from "@/store/forceStore";

export function FactionSelector() {
	const force = useForceStore(selectActiveForce);

	if (!force) return null;

	const faction = FACTIONS.find((f) => f.id === force.faction);

	if (!faction) return null;

	return (
		<div className="space-y-2">
			<h3 className="text-xs font-semibold text-text-muted uppercase tracking-wider px-1">
				Faction
			</h3>
			<div className="px-3 py-2.5 rounded-md text-sm bg-accent-primary/10 text-accent-primary border border-accent-primary/30">
				<div className="font-medium">{faction.name}</div>
				<div className="text-xs text-text-muted mt-1 leading-relaxed">
					{faction.description}
				</div>
			</div>
		</div>
	);
}
